import { types as t } from 'mobx-state-tree';

export const LoadingState = t.optional(
  t.enumeration('LoadingState', ['init', 'loading', 'loaded', 'error', 'reloading']),
  'init',
);
